"use client";

import styled from "styled-components";
import { backgroundColorAlt, spacing16 } from "@churchofjesuschrist/eden-style-constants";
import { dir } from "@churchofjesuschrist/eden-styled-helpers";
import { InternalUseOnlyRangeInput } from "./RangeInput";
import { RangeInputContext } from "../utils/context";
import { jsx as _jsx } from "react/jsx-runtime";
export const InternalUseOnlyMultiRangeField = styled.div.withConfig({
  componentId: "sc-8rq8jq-0"
})(["position:relative;isolation:isolate;height:", ";& ", "{position:absolute;&:first-child{isolation:auto;z-index:2;background:linear-gradient( to right,", " 0%,", " var(--lower-range-percentage),rgba(0,0,0,0) var(--lower-range-percentage),rgba(0,0,0,0) 100% );", "}&:last-child{isolation:auto;}&:last-child::after{content:\"\";position:absolute;top:50%;inset-inline-end:0;transform:translateY(-50%);height:", ";width:calc(100% - var(--lower-range-percentage));z-index:3;}}"], spacing16, InternalUseOnlyRangeInput, backgroundColorAlt, backgroundColorAlt, dir("rtl")`
        background: linear-gradient(
          to left,
          ${backgroundColorAlt} 0%,
          ${backgroundColorAlt}
          var(--lower-range-percentage),
          rgba(0,0,0,0) var(--lower-range-percentage),
          rgba(0,0,0,0) 100%
        );
      `, spacing16);

/**
 * Used to compose two `RangeInput` elements into a single slider.
 * @param {object} props - The component props
 * @param {string} [props.min] - The lowest value in the range of permitted values. Must be less than or equal to the value of the `max` prop. Overrides any `min` prop passed to either `<RangeInput>` child.
 * @param {string} [props.max] - The greatest value in the range of permitted values. Must be greater than or equal to the value of the `min` prop. Overrides any `max` prop passed to either `<RangeInput>` child.
 * @param {string} [props.step] - A number specifying the granularity that the value must adhere to. A string value of "any" means that no stepping is implied, and any value is allowed (while still respecting `min` and `max`).
 * @param {React.ReactNode} props.children - Must be two `<RangeInput>` elements where the first represents the "lower" value and the second represents the "upper" value selected within the range.
 * @returns {React.ReactElement} The MultiRangeField component
 */
const MultiRangeField = ({
  min = "0",
  max = "100",
  step = "1",
  children,
  ...props
}) => {
  const handleChange = event => {
    const target = event.target;
    const targetValue = target.value;
    const childrenArray = Array.from(target.parentNode.children);
    const index = childrenArray.indexOf(target);
    if (index === 0 && parseFloat(targetValue) >= parseFloat(childrenArray[1].value)) {
      childrenArray[0].value = (parseFloat(childrenArray[1].value) - parseFloat(step)).toString();
    } else if (index === 1 && parseFloat(targetValue) <= parseFloat(childrenArray[0].value)) {
      childrenArray[1].value = (parseFloat(childrenArray[0].value) + parseFloat(step)).toString();
    }
  };
  return /*#__PURE__*/_jsx(InternalUseOnlyMultiRangeField, {
    onInput: handleChange,
    ...props,
    children: /*#__PURE__*/_jsx(RangeInputContext.Provider, {
      value: {
        min,
        max,
        step
      },
      children: children
    })
  });
};
MultiRangeField.displayName = "MultiRangeField";
export default MultiRangeField;